import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconExpandAll(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <path d="M5 7L9 3L13 7" stroke="currentColor" strokeWidth={props.strokeWidth ?? 1.6} />
      <path d="M5 11L9 15L13 11" stroke="currentColor" strokeWidth={props.strokeWidth ?? 1.6} />
    </SVGIcon>
  );
}
